import React from 'react'
import { connect } from 'react-redux'
import OpenGames from '../components/open-games'

const mapStateToProps = (state) => ({
  ...state.openGames
})

const mapDispatchToProps = dispatch => ({
  onDateChange: payload => dispatch({type: 'OPEN_GAMES.DATE_CHANGE', payload}),
  onQuery: payload => dispatch({type: 'OPEN_GAMES.QUERY', payload}),
  onCancelled: payload => dispatch({type: 'OPEN_GAMES.CANCELLED', payload}),
  onUpcoming: payload => dispatch({type: 'OPEN_GAMES.UPCOMING', payload}),
  onTodoChange: payload => dispatch({type: 'OPEN_GAMES.TODO_CHANGE', payload}),
  onGameUpdate: payload => dispatch({type: 'OPEN_GAMES.GAME_UPDATE', payload}),
  onGamePaymentStatus: payload => dispatch({type: 'OPEN_GAMES.GAME_PAYMENT_STATUS', payload}),
  onLocationsUpdate: payload => dispatch({type: 'OPEN_GAMES.LOCATIONS_UPDATE', payload}),
  onRefreshGame: payload => dispatch({type: 'OPEN_GAME_MODAL.REFRESH_GAME', payload}),
  onBatchConfirm: payload => dispatch({type: 'OPEN_GAMES.BATCH_CONFIRM', payload}),
  onEndSelector: payload => dispatch({type: 'OPEN_GAMES.END_SELECTOR', payload}),
  setAlert: payload => dispatch({type: 'OPEN_GAMES.SET_ALERT', payload}),
  clearAlert: payload => dispatch({type: 'OPEN_GAMES.CLEAR_ALERT', payload}),
  setFilter: payload => dispatch({type: 'OPEN_GAMES.SET_FILTER', payload}),
  subscribeAdminMessages: payload => dispatch({type: 'FIRESTORE_CHANNEL.SUBSCRIBE_ADMIN', payload}),
  unsubscribeAdminMessages: payload => dispatch({type: 'FIRESTORE_CHANNEL.UNSUBSCRIBE_ADMIN', payload}),
  onGamesSelect: payload => dispatch({type: 'OPEN_GAMES.GAMES_SELECTOR', payload}),
  onCloseNotification: payload => dispatch({type: 'FIRESTORE_CHANNEL.MAKE_SEEN', payload}),
  onUpdateWithFacility: payload => dispatch({type: 'OPEN_GAMES.UPDATE_WITH_FACILITY', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenGames)
